import { eargoImages } from '@/assets/images';
var normalHearingIcon = eargoImages.normalHearingIcon, mildHearingIcon = eargoImages.mildHearingIcon, severeHearingIcon = eargoImages.severeHearingIcon;
export var hearingLevelsExplained = [
    {
        title: 'Normal hearing',
        description: 'You can hear conversations with good clarity when there is background noise.',
        color: 'text-eargo-fern-green',
        icon: normalHearingIcon,
    },
    {
        title: 'Mild-to-moderate hearing loss',
        description: 'You may have difficulty clearly following conversations when there is background noise.',
        color: 'text-eargo-earth-yellow',
        icon: mildHearingIcon,
    },
    {
        title: 'Out of range',
        description: 'You have severe difficulty following conversations when there is background noise.',
        color: 'text-eargo-red',
        icon: severeHearingIcon,
    },
];
